import { Button, Modal } from 'semantic-ui-react';
import React from 'react';
import WarningIcon from 'Assets/images/commons/warning.svg';

import styles from './OtpWarningModal.less';

interface Props {
  open: boolean;
  onClose: () => void;
  errorMsg: string;
  title: string;
}

const OtpWarningModal: React.FC<Props> = ({ open, onClose, errorMsg, title }) => {
  return (
    <Modal closeIcon onClose={onClose} open={open} size="tiny" closeOnDimmerClick={false}>
      <Modal.Content>
        <div className={styles.wrapPopup}>
          <img src={WarningIcon} alt="warning" />
          {title && <div className={styles.warningTitle}>{title}</div>}
          <div className={styles.warningContent}>{errorMsg}</div>
        </div>
      </Modal.Content>
      <Modal.Actions className={styles.actionsWrapper}>
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default OtpWarningModal;
